import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "How much money do I need to start a SIP?",
    a: "You can start with as little as ₹500 per month. What matters most is starting early and staying consistent — we help you pick funds matched to your goals and comfort with risk.",
  },
  {
    q: "Are mutual funds safe?",
    a: "Mutual funds are regulated by SEBI and your money is held with the fund house, not with us. Market-linked funds do carry risk, which is why we match every recommendation to your time horizon and risk appetite.",
  },
  {
    q: "What fixed income options do you offer?",
    a: "We advise on fixed deposits, corporate and government bonds, and small-savings schemes. These are suited for capital you cannot afford to risk — such as emergency funds or retirement income.",
  },
  {
    q: "How much term insurance cover do I need?",
    a: "A common rule of thumb is 10–15 times your annual income, but the right number depends on your loans, dependants, and goals. We calculate this with you on a free call before suggesting any plan.",
  },
  {
    q: "Do you charge for the first consultation?",
    a: "No. Your first consultation is completely free — just share your details on WhatsApp and we will call you back within 24 hours.",
  },
];

export const FAQ = () => (
  <section id="faq" className="py-20 lg:py-32 scroll-mt-20">
    <div className="max-w-7xl mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-12">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
        className="lg:col-span-5"
      >
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-bronze">Questions</p>
        <h2 className="mt-4 font-serif text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-forest">
          Everything you're wondering, answered honestly
        </h2>
        <p className="mt-5 text-base text-muted-foreground">
          Still unsure? Send us a message on WhatsApp and we'll call you back within 24 hours.
        </p>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5, delay: 0.15 }}
        className="lg:col-span-7"
      >
        <Accordion type="single" collapsible className="w-full">
          {FAQS.map((f, i) => (
            <AccordionItem key={f.q} value={`faq-${i}`} data-testid={`faq-item-${i}`} className="border-border">
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="text-left font-serif text-lg lg:text-xl font-medium text-forest hover:text-bronze hover:no-underline"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent data-testid={`faq-content-${i}`} className="text-sm lg:text-base text-muted-foreground">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </motion.div>
    </div>
  </section>
);
